import { brandingEnvironment, brandingIcon, type BrandEnvironment } from "../lib/branding";

export default function Brand({ environment = brandingEnvironment() }: { environment?: BrandEnvironment }) {
  return (
    <div className="brand">
      <img src={brandingIcon(environment, 96)} alt="" width={31} height={31} />
      <span>
        barnyard<span className="brand-dot">.</span>
      </span>
    </div>
  );
}
